import api from './api';

// Fetch the admin-set shipping config once per session (cached). Falls back to
// the previous hardcoded rule (₩5,000, free over ₩50,000) if the request fails.
let cachePromise = null;

const FALLBACK = { fee: 5000, threshold: 50000, firstOrderFree: false, firstOrderMin: 0, firstOrderEligible: false };

export function getShippingConfig() {
  if (!cachePromise) {
    cachePromise = api.get('/settings/shipping')
      .then((res) => ({
        fee: Number(res.data.shipping_fee ?? 5000),
        threshold: Number(res.data.free_shipping_threshold ?? 50000),
        // Sign-up perk. `firstOrderEligible` is decided by the server from the
        // signed-in customer's order history — it is false for guests.
        firstOrderFree: !!res.data.first_order_free_shipping,
        firstOrderMin: Number(res.data.first_order_free_shipping_min ?? 0),
        firstOrderEligible: !!res.data.first_order_eligible,
      }))
      .catch(() => FALLBACK);
  }
  return cachePromise;
}

// Eligibility changes the moment an order is placed (and on login/logout), so
// the cached answer has to be dropped or the next visit still shows "free".
export function clearShippingCache() {
  cachePromise = null;
}

// True when this amount qualifies for the first-order perk.
export function isFirstOrderFreeShipping(amount, cfg) {
  const c = cfg || FALLBACK;
  return !!c.firstOrderFree && !!c.firstOrderEligible && Number(amount) >= (c.firstOrderMin || 0);
}

// Delivery fee for an order amount given a config (free at/above threshold,
// or on a qualifying first order).
export function calcShipping(amount, cfg) {
  const c = cfg || FALLBACK;
  if (Number(amount) >= c.threshold) return 0;
  if (isFirstOrderFreeShipping(amount, c)) return 0;
  return c.fee;
}
